import RESTServicesService from 'src/services/RESTServicesService';

const restServicesService = new RESTServicesService();
export const GET_SERVICES = '@types/get-services';
export const GET_SERVICES_ERROR = '@types/get-services-error';

export function getDispatchServices() {
  return async (dispatch) => {
    try {
      const response = await restServicesService.getServices();
      dispatch({
        type: GET_SERVICES,
        payload: response
      });
      return { success: true, data: response };
    } catch (error) {
      dispatch({
        type: GET_SERVICES_ERROR,
        payload: error
      });
      return { success: false, error };
    }
  };
}
